import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateUserForm from "@/components/CreateUserForm";

export const Route = createFileRoute("/dashboard/clients/$id/users/new")({
  component: CreateUserPage,
});

function CreateUserPage() {
  const { id } = Route.useParams();
  return <CreateUserPageComponent businessId={id} />;
}

// Exported for testing
export function CreateUserPageComponent({
  businessId,
}: {
  businessId: string;
}) {
  return (
    <EntityFormPage
      title="Create User"
      description="Add a new user to this client."
      backHref={`/dashboard/clients/${businessId}`}
    >
      <CreateUserForm businessId={businessId} />
    </EntityFormPage>
  );
}
